import React, { ChangeEvent, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from '@components-shared/forms/Select/types';
import { Attributes } from '@components-shared/forms/formField.interface';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import cn from 'classnames';

interface ISelectorBodyProps {
  value: string | number;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  valid?: boolean;
  attributes?: Attributes;
  hideChooseText?: boolean;
  options: Option[];
  defaultSelectOption: string;
  name?: string;
}

export const SelectorBody = memo((props: ISelectorBodyProps): JSX.Element => {
  const { i18n } = useTranslation();
  const { value, onChange, valid, attributes, hideChooseText, options, defaultSelectOption, name } = props;

  return (
    <select
      className={cn('form__input', { invalid: !valid })}
      name={name}
      value={value}
      onChange={onChange}
      {...attributes}>
      {!hideChooseText && <option value="">{defaultSelectOption}</option>}
      {options.map((option, idx) => {
        const optionTitle = `${option.title || option.name || option.value}`;
        const optionTitleToDisplay: string = i18n.exists(optionTitle) ? i18n.t(optionTitle as KeyMapKeys) : optionTitle;

        return (
          <option key={`${option.value}_${idx}`} title={option?.optionTitle} value={option.value}>
            {optionTitleToDisplay}
          </option>
        );
      })}
    </select>
  );
});
